export const IMAGE_COLLECTION_TYPE_PHOTO = "PHOTO"
export const IMAGE_COLLECTION_TYPE_PANO = "PANO"
export const IMAGE_COLLECTION_TYPES = [IMAGE_COLLECTION_TYPE_PHOTO, IMAGE_COLLECTION_TYPE_PANO]
export const IMAGE_COLLECTION_TYPE_STREETVIEW = "STREETVIEW"